import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface ActivityStatsErrorStateProps {
  error: string;
}

const ActivityStatsErrorState: React.FC<ActivityStatsErrorStateProps> = ({ error }) => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6 mt-2">Activity Statistics</h2>
      <Card className="border-red-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-red-600 font-medium">Error loading activity statistics</p>
              <p className="text-sm text-red-500 mt-1">{error}</p>
            </div>
            <Badge variant="destructive">Error</Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ActivityStatsErrorState;